import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext'; // Import ThemeProvider

import Home from './pages/home';
import FootballPredictor from './pages/football-predictor';
import LabNinjas from './pages/lab-ninjas';
import Breadcrumbs from "./components/Breadcrumb";
import TermsBanner from './components/TermsBanner';

function App() {
  return (
    <ThemeProvider> {/* Wrap the entire app with ThemeProvider */}
      <Router>
        <Breadcrumbs />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/football-predictor" element={<FootballPredictor />} />
          <Route path="/lab-ninjas" element={<LabNinjas />} />
        </Routes>
        <TermsBanner />
      </Router>
    </ThemeProvider>
  );
}

export default App;
